
import {
  Grid,
  Row,
  Col,
  Button,
}from 'react-bootstrap';

import {
  ListContainer,
  ActWrapper,
}from './'

import {
  COLOR,
  PATH,
}from '../const';

var React = require('react');
var Radium = require('radium');
var FontAwesome = require('react-fontawesome');

var NavBk = require('../img/Blue-Gradient-Bk.jpg');

class ActHome extends React.Component {
  render() {
    return(
      <div>

        <ListContainer {...this.props}>
          <ActNavigation />
          <ActWrapper />
        </ListContainer>
      </div>
    )
  }
}

let ActNavigation = ({backButton = false, homeButton = false , listButton = false, changeView, titleText, history, match, inActivity, exitActivity, mode}) => {

  const handleBack = () => {
    history.push(PATH.home);
  }

  listButton = (inActivity) ? true : false;

  titleText = (mode.name) ? mode.name : 'Main Menu';

  backButton = !inActivity;
  homeButton = inActivity;


  return(
    <Grid fluid style={styles.navigation}>
      <Row style={styles.navRow}>
        <Col xs={2}>
          {backButton &&
            <NavButton
              name="arrow-left"
              onClick={handleBack}
            />
          }
          {!backButton && homeButton &&
            <NavButton
              name="home"
              onClick={exitActivity}
            />
          }
        </Col>
        <Col xs={8}>
          <h3 style={styles.navTitle}>{titleText}</h3>
        </Col>
        <Col xs={2}>
          {listButton &&
            <NavButton
              name="list-alt"
              onClick={changeView}
            />
          }
        </Col>
      </Row>
    </Grid>
  )
}

const NavButton = (props) => (
  <Button bsStyle="link" block style={styles.navButton} onClick={props.onClick}>
    <FontAwesome
      name={props.name}
      inverse={true}
      size="2x"
    />
  </Button>
)

const styles = {
  navigation: {
    color: COLOR.white,
    textAlign: 'center',
    backgroundImage: `url(${NavBk})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left top',
    backgroundSize: '100%',
    backgroundAttachment: 'fixed',
    paddingLeft: '2rem',
    paddingRight: '2rem',
    paddingTop: '8rem',
    paddingBottom: '1rem',
  },
  navButton: {
    border: '0',
  },
  navTitle: {
    color: COLOR.white,
    marginTop: '0',
    marginBottom: '0',
    fontSize: '30px'
  },
  navRow: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'row wrap',
  }
}

//Radium wrapper
ActNavigation = Radium(ActNavigation);

export default ActHome;



// WEBPACK FOOTER //
// ./src/comp/ActHome.js